import React, { FC } from "react";
import { ThemeBuilderSectionLine } from "./ThemeBuilderSectionLine";
import { WidgetLengthPicker } from "./WidgetLengthPicker";

export interface WidgetLengthPickerLineProps {
    readonly label?: string;
    readonly value: string | undefined;
    readonly defaultValue: string | undefined;
    readonly required?: boolean;
    readonly disabled?: boolean;
    onChange(value: string): void;
}

const WidgetLengthPickerLineInner: FC<WidgetLengthPickerLineProps> = props => {
    return (
        <ThemeBuilderSectionLine label={props.label}>
            <WidgetLengthPicker value={props.value} defaultValue={props.defaultValue} onChange={props.onChange} required={props.required} disabled={props.disabled} />
        </ThemeBuilderSectionLine>
    );
};

export const WidgetLengthPickerLine = React.memo(WidgetLengthPickerLineInner);
